module.exports = __webpack_public_path__ + "static/media/available.64038462.svg";